var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 info-block"},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }